import styled from 'styled-components'
import img from '../../../assets/login/bgimage.png'


export const Img = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-image: url(${img});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
`

export const LogoDiv = styled.div`
  height: 30px;
  border-top: 21px solid #fff;
`

export const Logo = styled.img`
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  margin: 21px 0 12px 0;
  

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    width: 140px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    width: 120px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    width: 100px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    width: 90px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    width: 80px;
  }
`

export const Container = styled.div`
  position: absolute;
  top: 10%;
  left: 35.5%;
  width: 475px;
  height: 300px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.32);
  overflow: auto;
  font-family: 'Roboto Slab', sans-serif;
  display: grid;

  

  * {
    padding: 0;
    margin: 0;
  }
`

export const Phrase = styled.h2`
    font-family: 'Roboto Slab', sans-serif;
    font-size: 0.9rem;
    font-weight: 500;
    font-style: normal;
    text-align: center;
    margin: 0 30px;
    line-height: 26px;
    color: #54595F;       
`

export const Phrase2 = styled.p`
  font-size: 0.82rem;
  font-family: 'Roboto Slab', sans-serif;
  font-weight: 500;
  font-style: normal;
  text-align: center;
  line-height: 18px;
  margin: 0  30px;
  color: #54595F;
`
